export enum InvoiceTypeEnum {
  UNDEFINED = -1,
  RECEIPT = 0,
  INVOICE_FOR_AN_INDIVIDUAL = 1,
  INVOICE_FOR_A_COMPANY = 2
}
